
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      fullName: string;
    };
    value: number;
  }>;
  label?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload }) => {
  const { t } = useLanguage();
  
  if (active && payload && payload.length) {
    const data = payload[0];
    const percentile = Math.round(data.value);
    
    const getPercentileDescription = (percentile: number): string => {
      if (percentile >= 80) return 'Very High';
      if (percentile >= 60) return 'High';
      if (percentile >= 40) return 'Moderate';
      if (percentile >= 20) return 'Low';
      return 'Very Low';
    };
    
    return (
      <div className="bg-background border border-border shadow-lg max-w-[90vw] md:max-w-xs rounded-lg p-3 md:p-4">
        <p className="font-bold text-foreground text-sm md:text-base mb-1 truncate">{data.payload.fullName}</p>
        <p className="text-sm md:text-base text-foreground/80 mb-1">
          <span className="font-semibold">{percentile}th percentile</span>
        </p>
        <p className="text-xs md:text-sm text-muted-foreground">
          {getPercentileDescription(percentile)} level
        </p>
      </div>
    );
  }
  return null;
};

export default CustomTooltip;
